import { createAction, handleActions } from 'redux-actions'

const setOriginalItems = createAction('SCREENS/SUB_ORDER/SET_ORIGINAL_ITEMS')
const resetOriginalItems = createAction('SCREENS/SUB_ORDER/RESET_ORIGINAL_ITEMS')

const defaultState = []

const reducer = handleActions(
  {
    [setOriginalItems]: (state, { payload }) => payload,
    [resetOriginalItems]: () => defaultState,
  },
  defaultState,
)

export { setOriginalItems, resetOriginalItems, reducer }
